/**
 * Binding for `morphicons`' `MorphIcon`: an icon morphing into its pair in place.
 *
 * The library defaults to `snappy`, a spring with a visible overshoot this brand
 * bans, and to `reducedMotion: "never"`, which ignores the OS setting. Every
 * morph is bound to this object so neither default reaches the app.
 */
export const morphProps = {
    spring: 'smooth',
    reducedMotion: 'user',
} as const;
